// extracted by mini-css-extract-plugin
export var details = "_kx-0";
export var inspectorPopover = "_kx-1";